var render = function render(){var _vm=this,_c=_vm._self._c;return _c('patientComponent',{attrs:{"hireState":2}})
}
var staticRenderFns = []

export { render, staticRenderFns }